import { API } from '@Providers';

interface RtoFeePayload {
  base_rto_fee: string;
  id: string;
  newLos: number;
  newRtoFee: string | number;
  rto_fee_type: 'flat' | 'daily';
  fee_name?: string;
}

export default async function (payload: RtoFeePayload) {
  const endpoint = '/api/shelter/animal/update-single-animal-rto-fee';

  return API({ endpoint, method: 'put', payload });
}
